import { isEmpty } from "lodash";

const ValidationErrorMessage = ({ message }) => {
  if (isEmpty(message)) return null;

  return <p className="text-red-600">{message}</p>;
};

export default ValidationErrorMessage;
